import { logError } from '@/utils/general'

interface DeviceIntelligenceResponse {
  result: {
    session_id: string
    device_intelligence?: Record<string, unknown> | null
  }
}

export const getShieldSessionId = async () => {
  try {
    const { getShield } = useShield()
    const shield = await getShield()
    const res = (await shield.getDeviceIntelligence()) as DeviceIntelligenceResponse

    const sessionId = res.result.session_id
    const deviceIntelligence = res.result.device_intelligence

    if (!sessionId) {
      logError(new Error('[shield] shieldSessionId is empty or null'))
    }

    if (!deviceIntelligence || Object.keys(deviceIntelligence).length === 0) {
      logError(new Error('[shield] device_intelligence is empty or null'))
    }

    return sessionId
  } catch (error) {
    logError(error, { context: 'getShieldSessionId' })
    return null
  }
}
